module.exports = __webpack_public_path__ + "img/KY.0e3cd4cc.png";